module.exports = __webpack_public_path__ + "static/media/nomine-calculate.75ab66cc.svg";